module.exports = __webpack_public_path__ + "img/Banner-Plantilla-GRANDE-2.e0889f13.png";